import { IAvailabilityV3BookingsResponse, IBookingsByOwnerIdParams, IBookingsStatisticsByOwnerIdParams } from '../../../api/bookings';
import { IBookingsStatistics, IEventV3 } from '../../../data/entities/event';
import { IProperty } from '../../../data/entities/property';

import { memoizedGroupBySelector } from '@travelnest/entities';
import * as React from 'react';
import { connect } from 'react-redux';
import { actions as entityActions } from '../../../data/store';
import { currentUserId } from '../../../entities/auth/session/selectors';
import { getBookingsByOwnerId, getBookingsStatsByOwnerId } from '../../../entities/bookings/actions';
import { IThunkDispatch } from '../../../store/middleware';
import { IState } from '../../../store/reducer';
import { toDateString } from './helpers';
import { OwnerBookingsComponent } from './OwnerBookings';

interface IOwnerBookingsContainerProps {
	customerId: string;
	bookings: IAvailabilityV3BookingsResponse;
	statistics: IBookingsStatistics;
	properties: IProperty[];
	loading: boolean;
	getProperties(id: string): any;
	getBookings(ownerId: string, params?: IBookingsByOwnerIdParams): IEventV3[];
	getBookingsStats(ownerId: string, params?: IBookingsStatisticsByOwnerIdParams): object[];
}

const mapDispatchToProps = (dispatch: IThunkDispatch) => ({
	getBookings: (ownerId: string, params?: IBookingsByOwnerIdParams) => dispatch(getBookingsByOwnerId(ownerId, params)).catch((e: any) => e),
	getBookingsStats: (ownerId: string, params?: IBookingsStatisticsByOwnerIdParams) =>
		dispatch(getBookingsStatsByOwnerId(ownerId, params)).catch((e: any) => e),
	getProperties: (id: string) => dispatch(entityActions.property.getByOwnerId(id)).catch((e: any) => e)
});

const mapStateToProps = (state: IState) => {
	const customerId = currentUserId(state);
	const customerProperties = memoizedGroupBySelector('owner_id', state.data.properties.byId)[customerId] || [];
	return {
		bookings: state.entities.bookings.byOwnerId[customerId],
		statistics: state.entities.bookings.statsByOwnerId[customerId],
		properties: customerProperties,
		loading: state.views.bookings.loadingBookings,
		customerId
	};
};

class OwnerBookingsContainer extends React.Component<IOwnerBookingsContainerProps> {
	private NUMBER_OF_DAYS = 30;

	public componentWillMount() {
		if (!this.props.bookings || !Object.keys(this.props.bookings).length) {
			this.props.getBookings(
				this.props.customerId,
				{ start_on: toDateString(new Date()), page_number: 1, page_size: 5, event_status: ['booked'] }
			);
		}
		if (!this.props.statistics) {
			this.props.getBookingsStats(this.props.customerId, { previous_num_days: this.NUMBER_OF_DAYS, next_num_days: this.NUMBER_OF_DAYS });
		}

		if (!this.props.properties || !this.props.properties.length) {
			this.props.getProperties(this.props.customerId);
		}
	}

	public render() {
		return <OwnerBookingsComponent
			customerId={this.props.customerId}
			bookings={this.props.bookings}
			statistics={this.props.statistics}
			numberOfDays={this.NUMBER_OF_DAYS}
			properties={this.props.properties}
			loading={this.props.loading}
		/>;
	}
}

export const OwnerBookings = connect(mapStateToProps, mapDispatchToProps)(OwnerBookingsContainer);
